import { h, Component, Fragment } from 'preact';
import SelectorComponent from './../components/selector.component.js';
import HeaderComponent from './../components/header.component.js';
import GeographySelectorComponent from './../components/geographySelector.component.js';
import RegionFilterComponent from './../components/regionFilter.component.js';
import StateFilterComponent from './../components/stateFilter.component.js';
import CountyFilterComponent from './../components/countyFilter.component.js';
import YearFilterComponent from './../components/yearFilter.component.js';
import ReportComponent from './../components/report.component.js';
import FooterComponent from './../components/footer.component.js';
import ModalComponent from '../components/modal.component';
// import BannerComponent from '../components/banner.component';
import dataService from '../services/data.service';

import { config } from './../config/config';

export default class MainView extends Component {
    constructor() {
        super();

        this.state = {
            dataType: '',
            geographyType: '',
            regions: [],
            states: [],
            counties: [],
            years: [],
            isModalOpen: false,
            modalOption: ''
        };
        this.dataId = 0;
    }

    async changeDataType(option) {
        // console.log('%cTRACE: changeDataType', 'color: green; font-weight: 900; background: white');
        // always reset all location filters when either data type or geography type change
        const newState = {
            regions: [],
            states: [],
            counties: [],
            years: []
        };

        newState.dataType = option;

        // is dataType did change, deselect current geography type if it is incompatiable with data type
        const geographyType = this.state.geographyType;
        if (option) {
            if (option && !option.geoTypes.includes(geographyType.id)) {
                newState.geographyType = '';
            }

            if (!option.years) {
                const years = await dataService.getYears(option.id);
                // sort most recent years first
                years.sort((a, b) => {
                    const aYear = parseInt(a.substring(0, 4), 10);
                    const bYear = parseInt(b.substring(0, 4), 10);
                    return bYear - aYear;
                });
                option.years = years.map(y => ({id: y, label: y}));
            }
            newState.years = [...option.years];
        }

        const self = this;
        self.setState(prevState => newState, () => self.getData());
    }

    changeGeographyType(option) {
        // console.log('%cTRACE: changeGeographyType', 'color: green; font-weight: 900; background: white');
        // always reset all location filters when either data type or geography type change
        const self = this;
        self.setState({
            geographyType: option,
            regions: [],
            states: [],
            counties: []
        }, () => self.getData());
    }

    toggleSelection(option, selectedField) {
        // console.log('%cTRACE: toggleSelection', 'color: green; font-weight: 900; background: white');
        const self = this;
        self.setState(prevState => {
            const selected = prevState[selectedField];
            const index = self.getIndex(option, selected);
            const newSelect = {};
            newSelect[selectedField] = {};
            if (index >= 0) {
                newSelect[selectedField] = selected.filter((x, i) => i !== index);
            }
            else {
                newSelect[selectedField] = [...selected, option];
            }
            return newSelect;
        }, () => self.getData());
    }

    setYears(selectedYears) {
        // console.log('%cTRACE: setYears', 'color: green; font-weight: 900; background: white');
        const self = this;
        self.setState(prevState => ({years: selectedYears}), () => self.getData());
    }

    getIndex(option, list) {
        // console.log('%cTRACE: getIndex', 'color: green; font-weight: 900; background: white');
        return list.findIndex(x => option.id === x.id);
    }

    clearFilters() {
        // console.log('%cTRACE: clearFilters', 'color: green; font-weight: 900; background: white');
        const self = this;
        self.setState(prevState => ({
            regions: [],
            states: [],
            counties: [],
            years: this.state.dataType?.years ? [...this.state.dataType.years] : []
        }), () => self.getData());
    }

    getFips() {
        // console.log('%cTRACE: getFips', 'color: green; font-weight: 900; background: white');
        const fips = [];
        this.state.geographyType.fipsTypes?.forEach(type => {
            if (type === 'region') {
                fips.push(...this.state.regions.map(x => x.id));
            }
            else if (type === 'state') {
                fips.push(...this.state.states.map(x => x.id));
            }
            else if (type === 'county') {
                fips.push(...this.state.counties.map(x => x.id));
            }
        });

        return fips;
    }

    async getData() {
        // console.log('%cTRACE: getData', 'color: green; font-weight: 900; background: white');
        this.dataId++;
        const curId = this.dataId;
        if (!this.state.dataType || !this.state.geographyType || this.state.years.length === 0) {
            return;
        }

        const years = this.formatYears(this.state.years);
        const fips = this.getFips();

        if (fips.length === 0) {
            if (this.state.data) {
                this.setState(prevState => ({data: undefined}));
            }
            return;
        }
        const data = await dataService.getReportData(this.state.dataType.id, this.state.geographyType.id, years, fips);
        // prevent old requests from rendering or up in the results | TODO - better approach?
        if (curId === this.dataId) {
            this.setState(prevState => ({data: data ?? []}));
        }
    }

    async getCsv() {
        // console.log('%cTRACE: getCsv', 'color: green; font-weight: 900; background: white');
        if (!this.state.dataType || !this.state.geographyType || this.state.years.length === 0) {
            return;
        }

        const years = this.formatYears(this.state.years);
        const fips = this.getFips();

        if (fips.length === 0) {
            return;
        }
        await dataService.getCsv(this.state.data, this.state.dataType.id, this.state.geographyType.id);
    }

    formatYears(years) {
        // console.log('%cTRACE: formatYears', 'color: green; font-weight: 900; background: white');
        // Years will come in either as a number (e.g. 2013) or will come in as a range
        // (e.g. 2014-2018). When coming in as a range, add only the high end of the range.
        // Reasoning for this is not known, but it's how it was before rewrite.
        return years.map(y => y.id);
    }

    openModal(option) {
        if (option) {
            this.setState({
                isModalOpen: true,
                modalOption: option
            });
        }
    }

    closeModal() {
        this.setState({
            isModalOpen: false
        });
    }

    render() {
        const self = this;
        return (
            <Fragment>
                <HeaderComponent />

                <section class="left_col">
                    <div class="report_types step-container">
                        <div class="step-number">1</div>
                        <div class="info-box">
                            <SelectorComponent
                                options={config.dataTypes}
                                onSelect={(option) => self.changeDataType(option)}
                                selected={self.state.dataType}
                                message="Select Data Type"
                                ga="QR Menu: Data Type"
                            />
                            <button class="info-btn" data-ga="QR Menu: Info Data" disabled={!self.state.dataType} onclick={() => self.openModal(self.state.dataType)} title="More Info">i</button>
                        </div>
                        <div class="info-box">
                            <GeographySelectorComponent
                                selectedDataType={self.state.dataType}
                                selectedGeographyType={self.state.geographyType}
                                onSelect={(option) => self.changeGeographyType(option)}
                            />
                            <button class="info-btn" data-ga="QR Menu: Info Geography" disabled={!self.state.geographyType} onclick={() => self.openModal(self.state.geographyType)} title="More Info">i</button>
                        </div>

                        <div class="infoless-box">
                            <YearFilterComponent
                                selectedDataType={self.state.dataType}
                                selectedYears={self.state.years}
                                updateSelectedYears={(option) => self.setYears(option)}
                            />
                        </div>
                    </div>

                    <div class="filters step-container">
                        <div class="step-number">2</div>
                        <div class="infoless-box">
                            <RegionFilterComponent
                                selectedDataType={self.state.dataType}
                                selectedGeographyType={self.state.geographyType}
                                selected={self.state.regions}
                                toggleSelect={(option) => self.toggleSelection(option, 'regions')}
                            />
                        </div>
                        <div class="infoless-box">
                            <StateFilterComponent
                                selectedDataType={self.state.dataType}
                                selectedGeographyType={self.state.geographyType}
                                selected={self.state.states}
                                toggleSelect={(option) => self.toggleSelection(option, 'states')}
                            />
                        </div>
                        <div class="infoless-box">
                            <CountyFilterComponent
                                selectedDataType={self.state.dataType}
                                selectedGeographyType={self.state.geographyType}
                                selectedStates={self.state.states}
                                selected={self.state.counties}
                                toggleSelect={(option) => self.toggleSelection(option, 'counties')}
                            />
                        </div>
                    </div>
                    <button class="clearFilters" data-ga="QR Menu: Reset" onclick={() => self.clearFilters()} value="Reset" title="Reset All Filters">Reset Filters</button>
                </section>

                <section class="right_col">
                    <ReportComponent dataType={self.state.dataType} data={self.state.data} />
                    {self.state.data &&
                    <div class="csv">
                        <button value="Download CSV" data-ga="QR: Download" onclick={() => self.getCsv()}>Download CSV</button>
                    </div>}
                </section>
                <FooterComponent />
                {/* <BannerComponent /> */}
                <ModalComponent isOpen={self.state.isModalOpen} option={self.state.modalOption} close={() => self.closeModal()} />
            </Fragment>
        );
    }
}
